export class Country {
    countryId: number;
    countryName: string;
    isOFACSanctioned: boolean;
    isInternational: boolean;
    abbreviation_1: string;
    abbreviation_2: string;

    constructor(countryId: number,
                countryName: string,
                isOFACSanctioned: boolean,
                isInternational: boolean,
                abbreviation_1: string,
                abbreviation_2: string) {
      this.countryId = countryId;
      this.countryName = countryName;
      this.isOFACSanctioned = isOFACSanctioned;
      this.isInternational = isInternational;
      this.abbreviation_1 = abbreviation_1;
      this.abbreviation_2 = abbreviation_2;
    }
  }
